import './../styles/Features.css';

function IconChat() {
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5Z"
        stroke="#2fe1c9"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function IconPerson() {
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 12a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z"
        stroke="#2fe1c9"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.5 21a7.5 7.5 0 0 1 15 0"
        stroke="#2fe1c9"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function IconCheck() {
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="9" stroke="#2fe1c9" strokeWidth="1.8" />
      <path
        d="M8 12.5l2.5 2.5L16 9.5"
        stroke="#2fe1c9"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function IconSparkle() {
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 2.5l1.8 5.4 5.4 1.8-5.4 1.8-1.8 5.4-1.8-5.4-5.4-1.8 5.4-1.8L12 2.5Z"
        stroke="#2fe1c9"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
      <path
        d="M19 15.5l.7 2 2 .7-2 .7-.7 2-.7-2-2-.7 2-.7.7-2Z"
        stroke="#2fe1c9"
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
    </svg>
  );
}

const FEATURES = [
  {
    icon: IconChat,
    title: 'Permissionless Onchain Finance',
    description: 'Compliance before state transition, on any chain or settlement rail.',
  },
  {
    icon: IconPerson,
    title: 'Built for Institutional Load',
    description:
      'Every state transition is gated by identity-bound policy, designed for regulated institutional flows.',
  },
  {
    icon: IconCheck,
    title: 'Sustainable Network Economics',
    description:
      'Per-request validation fees replace treasury subsidy. Economics reported in public every quarter.',
  },
  {
    icon: IconSparkle,
    title: 'Sovereign Infrastructure',
    description:
      'Settlement network across European financial hubs. State-backed by Telecom Liechtenstein: LTIN issues the verifiable identity; Zilliqa enforces it before settlement. No CLOUD Act exposure. Partner ecosystem at ltin.li.',
  },
];

export default function Features() {
  return (
    <section className="features">
      <div className="features__header">
        <h2>Built for institutional finance</h2>
        <p>A public chain that runs the check before settlement, on any chain or settlement rail.</p>
      </div>

      <div className="features__grid">
        {FEATURES.map(({ icon: Icon, title, description }) => (
          <div className="feature-card" key={title}>
            <Icon />
            <h3>{title}</h3>
            <p>{description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}